import React from 'react';
import '../../FormBuilder.css';

const CameraElement = ({ component, isRequired }) => {
  const renderElement = () => {
    return (
      component.elementName === 'camera' && (
        <label className='titleTextLbl'>
            {component.fieldName || "Camera"}
            <span className='requiredContainer' style={{ color: 'red' }}>{isRequired(component)}</span>
        </label>
      )
    );
  };

  return (
    <div className='renderAllElements'>
      {renderElement()}
    </div>
  );
};

export default CameraElement;
